export const projectsData = [
    {
        id: 1,
        projectName: 'Penn Cloud',
        projectDesc: 'PennCloud is a toy cloud platform where we simulated distributed systems environment with a load balancer for multiple instances of frontend servers as well as multiple backend servers with a master backend node.',
        tags: ['C++', 'TCP', 'Distributed Systems'],
        code: 'https://github.com/ruw321/GoogleSmallTable',
        demo: 'https://github.com/ruw321/GoogleSmallTable',
        image: '/img/project/PennCloud.jpg'
    },
    {
        id: 2,
        projectName: 'PubMigrations',
        projectDesc: 'A major issue faced by all developing economies is the emigration of their most educated population. This is known as a brain drain and it often limits the growth of developing countries. This project is a React WebApp that allows users to explore intriguing info regarding researchers’ migrations.',
        tags: ['React', 'Express', 'MongoDB', 'MySQL'],
        code: 'https://github.com/ruw321/PubMigrations',
        demo: 'https://github.com/ruw321/PubMigrations',
        image: '/img/project/PubMigration.png'
    },
    {
        id: 3,
        projectName: 'Penn Lobby',
        projectDesc: 'Penn Lobby is a single-page application using a full stack React.js and Node.js development tool that allow UPenn students to create groups, share posts, comment under posts as well as send private chat.',
        tags: ['React', 'NodeJS', 'Material Ui'],
        code: 'https://github.com/ruw321/PennLobby',
        demo: 'https://github.com/ruw321/PennLobby',
        image: '/img/project/PennLobby.jpg'
    },
    {
        id: 4,
        projectName: 'Mini Minecraft',
        projectDesc: 'This is an interactive 3D world exploration and alteration program in the style of the popular computer game Minecraft.',
        tags: ['C++', 'Computer Graphics'],
        code: 'https://github.com/ruw321/mini_minecraft',
        demo: 'https://www.youtube.com/watch?v=YDFq1TONUFo',
        image: '/img/project/MiniMinecraft.svg'
    },
    {
        id: 5,
        projectName: 'Instag',
        projectDesc: 'This is an Instagram clone with a custom Parse backend that allows a user to post photos, view a global photos feed, and add comments!',
        tags: ['Swift', 'iOS', 'Mobile App'],
        code: 'https://github.com/ruw321/Instag',
        demo: 'https://github.com/ruw321/Instag/blob/main/instaDemo.gif',
        image: '/img/project/Instag.svg'
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/